// import React from 'react';

// import ReactDOM from 'react-dom/client';

// import App from './App';
// window.addEventListener('vite:preloadError', (event) => {
//     window.location.reload(); // for example, refresh the page
// });

// const root = ReactDOM.createRoot(document.querySelector('#root') as HTMLElement);

// root.render(<App />);

import('./bootstrap');
